<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.4s ease-in-out;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active em versões anteriores a 2.1.8 */
  {
  opacity: 0;
}

.app__tt {
  background: #fff;
}

.app__tt__blocked {
  overflow: hidden;
}

.app__tt .hide__tt {
  display: none !important;
}

.app__tt #wrapper {
  height: 100%;
}

.app__tt #wrapper .wClasses {
  height: 100%;
}

.classes__tt {
  overflow: auto;
}

@media (min-device-width: 600px) and (max-device-width: 1280px) and (orientation: portrait) {
  .app__tt .survey__card__locked {
    height: calc(100vh - 32px);
  }

  .app__tt .card-header {
    font-size: 12px !important;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

@media (min-device-width: 600px) and (max-device-width: 1280px) and (orientation: landscape) {
  .app__tt .survey-card {
    height: calc(100vh - 32px);
  }
}

.app__tt .survey-card .secondary {
  padding-bottom: 5px !important;
}

/* Totem Portrait */
@media (min-device-width: 600px) and (max-device-width: 1280px) and (orientation: portrait) {
  .app__tt .hide__landscape {
    display: none !important;
  }

  .app__tt .show__landscape {
    display: block !important;
  }

  .app__tt .show__landscape .lead {
    font-size: 17px;
    font-weight: bold;
  }

  .app__tt .card__helper .likeDislike {
    padding: 0 !important;
  }

  .app__tt .footer {
    height: 25px;
    font-size: 10px;
  }

  .app__tt .survey-card {
    margin: 0 !important;
    box-shadow: none !important;
    border-radius: 0 !important;
  }

  .app__tt .survey__card__locked {
    height: calc(100vh - 25px);
  }

  .app__tt .thank-box {
    height: calc(100vh - 25px) !important;
  }

  .app__tt .progress {
    height: 25px !important;
  }
}

@media (min-device-width: 600px) and (max-device-width: 1280px) and (orientation: landscape) {
  .app__tt .logo__empresa {
    height: 10vh !important;
    display: block !important;
  }

  .app__tt .progress {
    height: 5vh !important;
  }

  .app__tt .hide__landscape {
    display: none !important;
  }

  .app__tt .show__landscape {
    display: block !important;
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .app__tt .thank-box {
    height: 65vh !important;
  }

  .app__tt .footer {
    height: 5vh !important;
  }

  .app__tt .survey-card {
    height: 70vh;
  }

  .app__tt .survey-card .primary {
    padding-top: 0 !important;
  }
}

@media (min-width: 900px) {

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s, transform 0.3s ease-in-out;
  }

  .fade-enter {
    transform: translateY(100px);
  }

  .fade-leave-to {
    transform: translateY(-100px);
  }
}

.spinner {
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>

<script>
import SoluCXFooter from '@/components/SoluCXFooter.vue';
export default { components: { SoluCXFooter } };
</script>
